// extracted by mini-css-extract-plugin
module.exports = {"container":"CopyUrl_container__3s2WK","disabled":"CopyUrl_disabled__TDVdb","text":"CopyUrl_text__1ukR9","input":"CopyUrl_input__1w2qa","copyButton":"CopyUrl_copyButton__1FPCw"};